var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{attrs:{"dense":"","loading":_vm.getLoading,"headers":_vm.headers,"items":_vm.getItems},scopedSlots:_vm._u([{key:"item.file",fn:function(ref){
var item = ref.item;
return [_c('v-btn',{attrs:{"dark":"","icon":"","target":"_blank","href":_vm.getUrlFile(item.file_name),"color":"primary"}},[_c('v-icon',[_vm._v("fa-paperclip")])],1)]}}],null,true)})}
var staticRenderFns = []

export { render, staticRenderFns }